// import '../DashboardUnique.css';

// export default function ElectionResultCard() {
//   return ( <div className={'govdash-summaryGrid'}>
//       <div className={`${'govdash-summaryCard'} ${'govdash-votersCard'}`}>
//         <div className={'govdash-cardContent'}>
//           <i className="fas fa-poll"></i>
//           <div>
//             <p className={'govdash-cardLabel'}>વિધાનસભા ચુંટણી પરિણામ</p>
//             {/* <span className={'govdash-cardValue'}>{voters.toLocaleString()}</span> */}
//           </div>
//         </div>
//         <div className={'govdash-cardBg'}></div>
//       </div>
//       <div className={`${'govdash-summaryCard'} ${'govdash-amountCard'}`}>
//         <div className={'govdash-cardContent'}>
//           <i className="fas fa-poll"></i>
//           <div>
//             <p className={'govdash-cardLabel'}>જિલ્લા પંચાયત ચુંટણી પરિણામ </p>
//             {/* <span className={'govdash-cardValue'}>₹{amount.toLocaleString()}</span> */}
//           </div>
//         </div>
//         <div className={'govdash-cardBg'}></div>
//       </div>
//       <div className={`${'govdash-summaryCard'} ${'govdash-labhartiCard'}`}>
//         <div className={'govdash-cardContent'}>
//           <i className="fas fa-poll"></i>
//           <div>
//             <p className={'govdash-cardLabel'}>તાલુકા પંચાયત ચુંટણી પરિણામ </p>
//             {/* <span className={'govdash-cardValue'}>{labharti.toLocaleString()}</span> */}
//           </div>
//         </div>
//         <div className={'govdash-cardBg'}></div>
//       </div>
//        <div className={`${'govdash-summaryCard'} ${'govdash-labhartiCard2'}`}>
//         <div className={'govdash-cardContent'}>
//           <i className="fas fa-poll"></i>
//           <div>
//             <p className={'govdash-cardLabel'}>કોર્પોરેશન ચુંટણી પરિણામ</p>
//             {/* <span className={'govdash-cardValue'}>{labharti.toLocaleString()}</span> */}
//           </div>
//         </div>
//         <div className={'govdash-cardBg'}></div>
//       </div>
//     </div>

//   );
// }

// import { useState } from "react";

// export default function ElectionResultCard() {
//   const [openSheet, setOpenSheet] = useState(null);

//   const electionCards = [
//     { id: 1, title: "વિધાનસભા ચુંટણી પરિણામ", class: "govdash-votersCard" },
//     { id: 2, title: "જિલ્લા પંચાયત ચુંટણી પરિણામ", class: "govdash-amountCard" },
//     { id: 3, title: "તાલુકા પંચાયત ચુંટણી પરિણામ", class: "govdash-labhartiCard" },
//     { id: 4, title: "કોર્પોરેશન ચુંટણી પરિણામ", class: "govdash-labhartiCard2" }
//   ];

//   const menuOptions = [
//     { label: "Summary Report PDF", icon: "fa-file", url: "/summary.pdf" },
//     { label: "Booth-Wise PDF", icon: "fa-building", url: "/booth.pdf" },
//     { label: "Ward-Wise PDF", icon: "fa-map", url: "/ward.pdf" },
//     { label: "Download All", icon: "fa-download", url: "/all.zip" }
//   ];

//   return (
//     <>
//       <div className="govdash-summaryGrid">
//         {electionCards.map(card => (
//           <div
//             key={card.id}
//             className={`govdash-summaryCard ${card.class}`}
//             onClick={() => setOpenSheet(card.id)}
//           >
//             <div className="govdash-cardContent">
//               <i className="fas fa-poll"></i>
//               <div>
//                 <p className="govdash-cardLabel">{card.title}</p>
//               </div>
//             </div>
//             <div className="govdash-cardBg"></div>
//           </div>
//         ))}
//       </div>

//       {/* Overlay */}
//       {openSheet && (
//         <div className="sheet-overlay" onClick={() => setOpenSheet(null)} />
//       )}

//       {/* Bottom Sheet */}
//       <div className={`bottom-sheet ${openSheet ? "open" : ""}`}>
//         <div className="sheet-header">
//           <div className="sheet-drag"></div>
//           <h3>Select Option</h3>
//         </div>

//         <div className="sheet-options">
//           {menuOptions.map((opt, i) => (
//             <div
//               key={i}
//               className="sheet-option"
//               onClick={() => window.open(opt.url, "_blank")}
//             >
//               <i className={`fas ${opt.icon}`}></i>
//               <span>{opt.label}</span>
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// }

import { useState } from "react";
import { useElectionResultCard, useIsMultipleElectionPDFs } from "../../../API_Master/FetchAPI";
import MediaCard from "../../../CommonComponents/MediaCard";
import { Narendra_Modi_Election_PDF_API_URL } from "../../../Process";
import ElectionCardShimmer from "./ElectionCardShimmer";
const THEMES = ["yojna-glass-0", "yojna-glass-1", "yojna-glass-2", "yojna-glass-3", "yojna-glass-4"];
export default function ElectionResultCard({ electionResultDashboardData, fetchingElectionResultDashboardData }) {
  const [openPdfMenus, setopenPdfMenus] = useState(null);
  const [electionLevel, setElectionLevel] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selPDF, setSelPDF] = useState("");
  const [openMultiplePdfMenus, setOpenMultiplePdfMenus] = useState(null);
  const [electionResultID, setElectionResultID] = useState("");

  const { data: electionLevelPDFs, isFetching: fetchingElectionLevelPdfs } = useElectionResultCard(electionLevel ? true : false, electionLevel);
  const { data: multiplePdfData, isFetching: fetchingMultiplePdfData } = useIsMultipleElectionPDFs(electionResultID ? true : false, electionResultID);

  const electionCards = ["govdash-votersCard", "govdash-amountCard", "govdash-labhartiCard3", "govdash-labhartiCard", "govdash-labhartiCard2"];

  const handleBack = () => {
    if (openMultiplePdfMenus) {
      setOpenMultiplePdfMenus(false);
      setElectionResultID("");
    } else {
      setElectionLevel("");
      setopenPdfMenus(null);
    }
    setShowModal(false);
    setSelPDF("");
  };
  const openOrDownloadPdf = async (pdfName) => {
    const cleanPdfName = pdfName?.trim();
    if (!cleanPdfName) return;

    if (!window.matchMedia("(max-width: 768px)").matches) {
      setShowModal(true);
      setSelPDF(cleanPdfName);
      return;
    }

    const fileName = `${cleanPdfName}.pdf`;
    const pdfUrl = `${Narendra_Modi_Election_PDF_API_URL}${fileName}`;

    try {
      const response = await fetch(pdfUrl);
      if (!response.ok) throw new Error("PDF download failed");

      const pdfBlob = await response.blob();
      const blobUrl = URL.createObjectURL(pdfBlob);
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      const downloadLink = document.createElement("a");
      downloadLink.href = pdfUrl;
      downloadLink.download = fileName;
      downloadLink.rel = "noopener noreferrer";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
    }
  };
  return (
    <>
      {fetchingElectionLevelPdfs || fetchingMultiplePdfData || fetchingElectionResultDashboardData ? (
        <ElectionCardShimmer />
      ) : (
        <>
          {openPdfMenus && (
            <button
              id="govdash-back-btn"
              className={"govdash-backBtn"}
              onClick={() => {
                // setElectionLevel("");
                // setopenPdfMenus(null);
                // setShowModal(false);
                // setSelPDF("");
                handleBack();
              }}
            >
              {" "}
              Back
            </button>
          )}
          {!openPdfMenus && (
            <div className="govdash-summaryGrid">
              {electionResultDashboardData?.map((card, i) => {
                const theme = electionCards[i % 5];
                return (
                  <div
                    key={card.ElectionResultTypeID}
                    className={`govdash-summaryCard ${theme}`}
                    onClick={() => {
                      setElectionLevel(card.ElectionResultTypeName);
                      setopenPdfMenus(card.ElectionResultTypeID);
                    }}
                  >
                    <div className="govdash-cardContent">
                      <i className="fas fa-poll"></i>
                      <div>
                        <p className="govdash-cardLabel">{card.ElectionResultTypeName}</p>
                      </div>
                    </div>
                    <div className="govdash-cardBg"></div>
                  </div>
                );
              })}
            </div>
          )}

          {openPdfMenus && !openMultiplePdfMenus && (
            <div className="govdash-summaryGrid">
              {electionLevelPDFs && electionLevelPDFs.length > 0 ? (
                electionLevelPDFs.map((PDF, index) => (
                  <div
                    key={PDF.PdfName}
                    className={`govdash-summaryCard ${electionLevelPDFs.length === 1 ? "single-card-width" : ""}`}
                    style={{
                      background: `linear-gradient(
                        135deg,
                        hsl(${index * 137.5}, 65%, 55%) 0%,
                        hsl(${index * 137.5 + 25}, 70%, 45%) 100%
                      )`,
                    }}
                    onClick={() => {
                      if (PDF.IsMultiplePDF) {
                        setOpenMultiplePdfMenus(true);
                        setElectionResultID(PDF.ElectionResultID);
                      } else {
                        openOrDownloadPdf(PDF.PdfName);
                      }
                      // setShowModal(true);
                      // setSelPDF(PDF.PdfName);
                    }}
                  >
                    <div className="govdash-cardContent">
                      <i className="fas fa-poll"></i>
                      <div>
                        <p className="govdash-cardLabel">{PDF.Type}</p>
                      </div>
                    </div>
                    <div className="govdash-cardBg"></div>
                  </div>
                ))
              ) : (
                <div className=" no-pdf-card">
                  <div style={{ fontSize: "60px", marginBottom: "20px", color: "#888" }}>
                    <i className="fas fa-file-alt"></i>
                  </div>
                  <p style={{ fontSize: "22px", fontWeight: "600", marginBottom: "8px" }}>No PDFs Available</p>
                  <p style={{ fontSize: "14px", color: "#777", maxWidth: "200px" }}>There are currently no PDF reports for this election level.</p>
                </div>
              )}
            </div>
          )}

          {openMultiplePdfMenus && (
            <div className="govdash-summaryGrid">
              {multiplePdfData && multiplePdfData.length > 0 ? (
                multiplePdfData.map((PDF, index) => (
                  <div
                    key={PDF.PdfName}
                    className={`govdash-summaryCard ${multiplePdfData.length === 1 ? "single-card-width" : ""}`}
                    style={{
                      background: `linear-gradient(
                        135deg,
                        hsl(${index * 137.5}, 65%, 55%) 0%,
                        hsl(${index * 137.5 + 25}, 70%, 45%) 100%
                      )`,
                    }}
                    // onClick={() => {
                    //   setShowModal(true);
                    //   setSelPDF(PDF.PdfName?.trim());
                    // }}
                    onClick={() => {
                      openOrDownloadPdf(PDF.PdfName);
                    }}
                  >
                    <div className="govdash-cardContent">
                      <i className="fas fa-poll"></i>
                      <div>
                        <p className="govdash-cardLabel">{PDF.Type}</p>
                      </div>
                    </div>
                    <div className="govdash-cardBg"></div>
                  </div>
                ))
              ) : (
                <div className="no-pdf-card">
                  <div style={{ fontSize: "60px", marginBottom: "20px", color: "#888" }}>
                    <i className="fas fa-file-alt"></i>
                  </div>
                  <p style={{ fontSize: "22px", fontWeight: "600", marginBottom: "8px" }}>No PDFs Available</p>
                  <p style={{ fontSize: "14px", color: "#777", maxWidth: "200px" }}>There are currently no PDF reports for this election level.</p>
                </div>
              )}
            </div>
          )}

          <MediaCard showModal={showModal} setShowModal={setShowModal} fileType="pdf" pdfName={selPDF} />
        </>
      )}
    </>
  );
}
